const handleProductColorChange = (
  products,
  setIsLoading,
  setCurrentColorProduct
) => {
  return id => {
    setIsLoading(true);
    const newProduct = products.find(product => product.id === id);

    if (!newProduct) {
      return;
    }

    const newImage = new Image();
    const nextImageUrl = newProduct?.image_url;

    newImage.src = nextImageUrl;
    if (nextImageUrl) {
      window[nextImageUrl] = nextImageUrl;
    }

    setTimeout(() => {
      setCurrentColorProduct(newProduct);
      setIsLoading(false);
    }, 500);
  };
};

export default handleProductColorChange;
